// extracted by mini-css-extract-plugin
export default {"input":"ReportProblemDialog_input__15tt2","button":"ReportProblemDialog_button__Xyf46"};